import React from "react";
import { cleanDate } from "../../../../util/app";
import RenderHtml from "react-render-html";
import StaffProfileCard from "../../../Staff/partials/StaffProfileCard";

const PlanDetail = ({ item, onConfirm, onComplete, onReView, onRePlan }) => {
    return (
        <>
            {item.confirm.status && (
                <div className="row">
                    <div className="col-3 bg-primary text-center">
                        <h5>Status</h5>
                    </div>
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: "#0abb9d", color: "white" }} className="text-center" colSpan="4">
                                    <span className="w-100">Confirmed</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue" }}>
                                    <strong>Confirmed By</strong>
                                </td>
                                <td>
                                    <StaffProfileCard item={item.confirm.author} />
                                </td>
                                <td style={{ backgroundColor: "aliceblue" }}>
                                    <strong>Confirmed Date & Time</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{cleanDate(item.confirm.date, false, false)}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}
            {!item.confirm.status && (
                <div className="row">
                    <div className="col-3 bg-primary text-center">
                        <h5>Status</h5>
                    </div>
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ color: "white" }} className="text-center bg-danger" colSpan="4">
                                    <span className="w-100">UnConfirmed</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}
            <div className="row">
                <div className="col-3 bg-primary text-center">
                    <h5>Plan Header</h5>
                </div>
                <div className="col-12">
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                    <strong>Plan Status</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{item.header.status}</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                    <strong>Date & Time Commenced</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{cleanDate(item.header.dateCommenced)}</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                    <strong>Type of Plan</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{item.header.typePlan}</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                    <strong>Discipline</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{item.header.discipline}</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                    <strong>Title Group</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{item.header.titleGroup}</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                    <strong>Title</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{item.header.title}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="row">
                <div className="col-3 bg-primary text-center">
                    <h5>Physical Health Plan Areas</h5>
                </div>
                <table className="table table-bordered">
                    <tbody>
                        {item.carePlanAreas.map((i, idx) => (
                            <tr key={idx}>
                                <td className="text-right" style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                    <strong>{i}</strong>
                                </td>
                                <td>
                                    <span className="material-icons text-primary">check_box</span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="row">
                <div className="col-3 bg-primary text-center">
                    <h5>Plan Detail</h5>
                </div>
                <div className="col-12">
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                    <strong>Reason for Careplan</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{item.reason}</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                    <strong>Description of Identified Need</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{item.desc}</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                    <strong>Planned Goals/Aim</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{item.goal}</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                    <strong>Intervention</strong>
                                </td>
                                <td>
                                    <span>{RenderHtml(item.intervention)}</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                    <strong>Evidence/Research for Intervention</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{item.evidence}</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                    <strong>Patient Comment / Evidence of involvement in forming this plan</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{item.patientComment}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="row">
                <div className="col-3 bg-primary text-center">
                    <h5>Evaluation</h5>
                </div>
                <div className="col-12">
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                    <strong>Next Evaluation Alert Date</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{cleanDate(item.evaluation.nextDate)}</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                    <strong>Evaluation Alert Contact</strong>
                                </td>
                                <td>
                                    <span className="text-primary">
                                        <StaffProfileCard item={item.evaluation.contact} />
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                    <strong>Evaluation (Please detail of the patient involvement in the evaluation)</strong>
                                </td>
                                <td>
                                    <div className="col-12">
                                        <span>{RenderHtml(item.evaluation.evaluation)}</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            {item.confirm.status ? (
                <>
                    {!item.terminated && (
                        <div className="row fade-in">
                            <div className="col-12 text-center mt-5 mb-5">
                                <button
                                    onClick={() => onComplete({ item, status: "Achieved" })}
                                    type="button"
                                    className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-right-10 btn-circle btn-success"
                                >
                                    Achieved <i className="material-icons">check</i>
                                </button>
                                <button
                                    onClick={() => onComplete({ item, status: "Discontinue" })}
                                    type="button"
                                    className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-right-10 btn-circle"
                                >
                                    Discontinue <i className="material-icons text-danger">close</i>
                                </button>
                                <button onClick={() => onReView(item)} type="button" className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-right-10 btn-circle">
                                    Review Now <i className="material-icons text-success">edit</i>
                                </button>
                                <button onClick={() => onRePlan(item)} type="button" className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-right-10 btn-circle btn-primary">
                                    RePlan <i className="material-icons">cached</i>
                                </button>
                            </div>
                        </div>
                    )}
                </>
            ) : (
                <button onClick={() => onConfirm(item)} title="Confirm" className="mdl-button mdl-button--icon mdl-button--colored btn-default ml-2">
                    <i className="material-icons text-success">check_circle</i>
                </button>
            )}
        </>
    );
};

export default PlanDetail;
